(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mh-rsc-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__mhRscProductCardSwatchesBound) return;
  window.__mhRscProductCardSwatchesBound = true;

  function canHover() {
    return window.matchMedia && window.matchMedia("(min-width: 989px)").matches;
  }

  function activate(link) {
    var card = link.closest(".mh-rsc-product-card");
    if (!card) return;

    var wrap = link.querySelector(".mh-rsc-product-card__swatch-imgwrap");
    if (!wrap) return;

    var img360 = wrap.getAttribute("data-image");
    if (!img360) return;

    var mainImg = card.querySelector(".mh-rsc-product-card__media-img");
    if (!mainImg) return;

    mainImg.src = img360;
    mainImg.removeAttribute("srcset");
    mainImg.removeAttribute("sizes");

    var all = card.querySelectorAll(".mh-rsc-product-card__swatch-link");
    Array.prototype.forEach.call(all, function (a) {
      var isActive = a === link;
      a.classList.toggle("mh-rsc-product-card__swatch-link--active", isActive);
      a.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  // Swatch image fallback:
  // If the first (lowercase) URL 404s, try: keep-case hyphen -> underscore -> space
  function handleSwatchImgError(img) {
    if (!img) return;

    var fallbacksRaw = img.getAttribute("data-fallbacks") || "";
    if (!fallbacksRaw) {
      img.style.display = "none";
      return;
    }

    var list = fallbacksRaw.split("||").filter(Boolean);
    var idx = parseInt(img.getAttribute("data-fallback-idx") || "0", 10);

    // move to next fallback
    if (idx >= list.length) {
      img.style.display = "none";
      return;
    }

    img.setAttribute("data-fallback-idx", String(idx + 1));
    img.src = list[idx];
  }

  // Use capture so we catch image errors reliably
  document.addEventListener(
    "error",
    function (evt) {
      var img = evt.target;
      if (!img || !img.classList || !img.classList.contains("mh-rsc-product-card__swatch-img")) return;
      handleSwatchImgError(img);
    },
    true
  );

  // CLICK always (desktop + mobile)
  document.addEventListener("click", function (evt) {
    var a = evt.target.closest(".mh-rsc-product-card__swatch-link");
    if (!a) return;
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
    evt.preventDefault();
    activate(a);
  });

  // HOVER only on desktop (>=989px)
  document.addEventListener("mouseover", function (evt) {
    if (!canHover()) return;
    var a = evt.target.closest(".mh-rsc-product-card__swatch-link");
    if (!a) return;
    activate(a);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
